
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import StepList from "@/components/scope/step-list.vue";
import dayjs from "dayjs";
import ConfirmPaymentItem from "./components/confirm-payment.vue";
import RegisterInvoice from "./components/register-invoice.vue";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";
import InWarehouseConfirm from "./components/in-warehouse-confirm.vue";

const service = namespace("service");
const setting = namespace("setting");
const purchase = namespace("purchase");
const app = namespace("app");
const base = namespace("base");

@Component({
  components: {
    StepList,
    ConfirmPaymentItem,
    RegisterInvoice,
    InWarehouseConfirm
  }
})
export default class PurchaseView extends Vue {
  @purchase.Action purchaseComplete;
  @purchase.Action getPurchaseDetail;
  @purchase.Action purchaseCancel;
  @service.Action createInvoice;
  @purchase.Action createPurchasePayment;
  @purchase.Mutation setPaymentBtnLoading;
  @purchase.Mutation setMakeInvoiceBtnLoading;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @setting.Action getPatternPaymentList;
  @purchase.Action purchaseBatchCompleted;
  @base.Action jumpPrintPage;
  dayjs = dayjs;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  get breadData() {
    return [
      { name: t("purchase.purchase-manage"), path: "/purchase/index" },
      { name: t("v210906.view-purchase-order") }
    ];
  }
  get additionalList() {
    if (!this.detailData.additionalFees) {
      return [];
    }
    return [
      {
        additionalFees: this.detailData.additionalFees,
        returnAdditionalFees: this.detailData.returnAdditionalFees,
        additionalFeesRemark: this.detailData.additionalFeesRemark
      }
    ];
  }
  get cancelData() {
    if (this.detailData.cancelBean) {
      return [this.detailData.cancelBean];
    }
    return [
      {
        receiptNo: this.detailData.receiptNo,
        receiptAmount: this.detailData.receiptAmount,
        cancelDate: this.detailData.cancelDate,
        cancelRemark: this.detailData.cancelRemark,
        cancelOperatorName: this.detailData.cancelOperatorName
      }
    ];
  }
  paymentData: any = {};
  payWayList: any = [];
  created() {
    this.init();
    this.getPatternPaymentList({
      status: "1"
    }).then(data => {
      this.payWayList = this.$safeValue(data, "data", []);
    });
  }
  cancelForm: any = {
    remark: "",
    paidAmount: "",
    paidMethod: ""
  };
  cancelFormRules: any = {
    supplierName: [{ required: true, message: t("setting.enter-supplier-name"), trigger: "blur" }]
  };
  showCancel: boolean = false;
  handleMoreMenuClick(command) {
    if (command === "cancel") {
      this.showCancel = true;
    }
    if (command === "return") {
      let { href } = this.$router.resolve({
        path: `/purchase/purchase-refund-add?order=${this.detailData.purchaseNo}`
      });
      window.open(href, "_blank");
    }
  }
  handleCancel() {
    this.purchaseCancel({
      purchaseNo: this.orderId,
      ...this.cancelForm
    }).then(() => {
      this.showCancel = false;
      this.$message.success(t("finance.cancel-success"));
      this.init();
    });
  }
  handlePaymentConfirmClick(data) {
    let params = {
      orderList:
        data.settleType === 1
          ? [{ orderNo: this.orderId }]
          : data.selectedRows.map(item => {
              item.orderNo = item.purchaseNo;
              return item;
            }),
      paidList: [
        {
          paidAmount: data.settleType === 1 ? data.paidAmount : 0,
          paidMethod: data.paidMethod
        }
      ],
      remark: ""
    };
    this.setPaymentBtnLoading(true);
    this.createPurchasePayment(params)
      .then(() => {
        this.$message.success(t("base.payment-success"));
        this.showComfirmPayment = false;
        this.init();
      })
      .finally(() => {
        this.setPaymentBtnLoading(false);
      });
  }
  handleInvoiceConfirmClick(data) {
    this.setMakeInvoiceBtnLoading(true);
    this.createInvoice(data)
      .then(() => {
        this.$message.success(t("purchase.invoice-register-success") as string);
        this.showRegisterInvoice = false;
        this.init();
      })
      .finally(() => {
        this.setMakeInvoiceBtnLoading(false);
      });
  }
  get orderId() {
    return this.$route.params.id;
  }
  showComfirmPayment: boolean = false;
  showRegisterInvoice: boolean = false;
  emptyToLine = emptyToLine;
  detailData: any = { purchaseStatus: "2", photoList: [] };
  showInwarehouse = false;
  handleShowComplete() {
    this.showInwarehouse = true;
  }
  handleComfirmPaymentShow() {
    this.showComfirmPayment = true;
  }
  handleRegisterInvoice() {
    this.showRegisterInvoice = true;
  }
  handleArriveStore() {
    this.$router.push(`/service/arrive/input/${this.orderId}`);
  }

  init() {
    this.getPurchaseDetail({
      purchaseNo: this.orderId
    }).then(data => {
      this.detailData = data.data;
      let purchaseReturnList = JSON.parse(JSON.stringify(this.detailData.purchaseReturnList));
      this.detailData.purchaseReturnFirst =
        purchaseReturnList && purchaseReturnList.length ? purchaseReturnList[0].returnPurchaseNo : "";
      this.detailData.purchaseReturnMore =
        purchaseReturnList && purchaseReturnList.length > 1 ? purchaseReturnList.splice(1) : [];
      if (this.detailData.settlementStatus === "1") {
        this.cancelForm.paidAmount = this.detailData.purchaseAmount ? Number(this.detailData.purchaseAmount) : 0;
      }
    });
  }
  showBatchInWarehouse = false;
  handleComplete(selectionRows) {
    this.btnStartLoading();
    let completedFunc;
    if (selectionRows?.length) {
      completedFunc = () => {
        return this.purchaseBatchCompleted({ purchaseNoList: selectionRows.map(item => item.purchaseNo) });
      };
    } else {
      completedFunc = () => {
        return this.purchaseComplete({
          purchaseNo: this.orderId
        });
      };
    }
    completedFunc()
      .then(() => {
        this.showInwarehouse = false;
        this.$message.success(t("warehouse.inbound-success") as string);
        this.init();
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  handlePrint() {
    this.jumpPrintPage({ category: "PRINT_PURCHASE", documentNo: this.detailData.purchaseNo });
  }
  get urlShowCompleted(): boolean {
    return !!this.$route.query.showCompleted;
  }
  handleLinkOrderView(orderNo) {
    let { href } = this.$router.resolve({
      path: `/service/view/${orderNo}`
    });
    window.open(href, "_blank");
  }
}
